import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, PageChangeEvent, PagerSettings, SelectableSettings } from '@progress/kendo-angular-grid';
import { DataResult, State,process, SortDescriptor } from '@progress/kendo-data-query';
import moment from 'moment';
import { ContactsService, PS_Lst_Contacts_Result, SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'app-lst-contacts',
  templateUrl: './lst-contacts.component.html',
  styleUrls: ['./lst-contacts.component.scss']
})
export class LstContactsComponent implements OnInit {

  constructor(
    private sharedDataSvc: SharedDataService,
    private contactsSvc:ContactsService
  ) { }

  LstContacts:PS_Lst_Contacts_Result[]=[];
  public gridDatas: DataResult;


  public state: State = {
    skip: 0,
    take: 100,  
    sort:  [{
      field: "SupplierName",
      dir: "asc",
    }]
    //group:  [{ field: "ProfilLib" }]
  };
  public pagerSettings:PagerSettings = {
    position: 'top',
    pageSizes: [20,50,100],
    previousNext: true,
    responsive: true,
    type:'numeric'
  }
  
  
  public selectableSettings: SelectableSettings = {
    checkboxOnly:false,
    mode: 'single',
    drag: false,
  }
  ngOnInit(): void {
    this.sharedDataSvc.RedirectToDefaultScreenIfNotAllowed('LST_CONTACTS');
    this.reloadcontacts();
  }

  reloadcontacts():void{
    this.sharedDataSvc.WindowLock();
    this.contactsSvc.LstContacts().subscribe(results=> {
      results.forEach(item=>{
        (<any>item).canAccessPortail = (item.AccesPortail==1);
      });
      this.sharedDataSvc.WindowUnlock();
      this.LstContacts = results;
      this.refreshDataGrid();
    },
    reject=>{
      this.sharedDataSvc.alert(reject.error || JSON.stringify(reject));
    });
  }

  get isAdmin():boolean{
    return this.sharedDataSvc?.isAdmin || false;
  }

   
  pageChange({ skip, take }: PageChangeEvent): void {
    this.state.skip = skip;
    this.state.take = take;
    this.refreshDataGrid();
  }
  refreshDataGrid():void{
        this.gridDatas = process(this.LstContacts,  this.state);
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    state.group = this.state.group;
    this.state = state;
    this.refreshDataGrid();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.state.sort = sort;
    this.refreshDataGrid();
  }

  // Si 1 case cochée, sinon case non cochée
  checkNgClass(fieldValue: number): any {    
    return {
      'far': true,
      'fa-check-square': (fieldValue == 1),
      'fa-square': (fieldValue != 1),
    }
  }

  
 
  public getSupplierLink(item:any):string {
    if (!(item||{}).SupplierId) return '';
    return '/supplier-details/'+item.SupplierId+'/lst-contacts';
  }
  
  get excelFilename():string {
    return 'Contacts-'+ moment().format('DD-MM-YYYY-HHmm') +'.xlsx'
  }
}
